export interface ShareApiData {
  text?: string;
  title?: string;
  url?: string;
}

export function useShareApi() {
  const canShare = navigator.canShare;

  const shareData = async ({ text, title, url }: ShareData) => {
    try {
      await navigator.share({
        title,
        text,
        url,
      });
    } catch (e) {
      throw new Error(e);
    }
  };

  return { canShare, shareData };
}
